import { render } from "./MsgSend.vue?vue&type=template&id=24a71490&scoped=true"
import script from "./MsgSend.vue?vue&type=script&lang=js"
export * from "./MsgSend.vue?vue&type=script&lang=js"

import "./MsgSend.vue?vue&type=style&index=0&id=24a71490&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a71490"]])

export default __exports__